import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import styles from '../../BankTransferDisplayForm.scss'

class ChequeForm extends Component {
    static propTypes = {
      form: PropTypes.object.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleFocus: PropTypes.func.isRequired,
      handleValidation: PropTypes.func.isRequired,
      schema: PropTypes.object.isRequired,
    }

    render() {
      const {
        schema, form, handleChange, handleValidation, handleFocus,
      } = this.props      
      return (
        <div className={styles.fieldset}>
          <li>
            <TextInput
              {...schema.payee}
              error={form.payee.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.payee.value}
              valid={form.payee.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.amount}
              error={form.amount.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.amount.value}
              valid={form.amount.valid}
            />
          </li></div>
      )
    }
}

export default ChequeForm



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/components/BankTransfer/ChequeForm.js